/**
 * Formats a given number or string to two decimal places.
 * 
 * @param {number | string | null | undefined} value - The value to be formatted.
 * @returns {string} The formatted value as a string with two decimal places, or an empty string if the input is invalid.
 */
export const formatToTwoDecimalPlaces = (value: number | string | null | undefined): string => {
  if (value == null || isNaN(Number(value))) return '';
  return parseFloat(Number(value).toFixed(2)).toString();
};
